import { useEffect, useRef } from 'react'
import { useAuth } from '@/hooks/useAuth'
import { realtime } from '@/lib/realtime-events'

export function useRealtimeConnection() {
  const { token } = useAuth()
  const tokenRef = useRef(token)

  useEffect(() => {
    tokenRef.current = token
    console.log('[SSE] useRealtimeConnection — token:', token ? `${token.slice(0, 10)}...` : 'null/undefined')
    if (!token) {
      console.warn('[SSE] Skipping SSE connect — no auth token available')
      return
    }
    realtime.connect(token)

    const handleVisibility = () => {
      if (!document.hidden && tokenRef.current) {
        console.log('[SSE] Tab visible, reconnecting')
        realtime.connect(tokenRef.current)
      }
    }
    document.addEventListener('visibilitychange', handleVisibility)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibility)
    }
  }, [token])
}

export function useRealtimeEvent(event: string, callback: (data: any) => void) {
  const cbRef = useRef(callback)
  cbRef.current = callback

  useEffect(() => {
    return realtime.on(event, (data) => cbRef.current(data))
  }, [event])
}
